var _defs, _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoConcept2ChartFlame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireGrad2",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ef4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#f97316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireGrad2b",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f59e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f97316"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#030712",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow2)",
    transform: "translate(200,165)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: 20,
    width: 22,
    height: 80,
    rx: 3,
    fill: "#f97316",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -54,
    y1: 10,
    x2: -54,
    y2: 105,
    stroke: "#f97316",
    strokeWidth: 2.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11,
    y: -10,
    width: 22,
    height: 110,
    rx: 3,
    fill: "#f97316",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -20,
    x2: 0,
    y2: 105,
    stroke: "#f97316",
    strokeWidth: 2.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 10,
    width: 22,
    height: 90,
    rx: 3,
    fill: "url(#fireGrad2)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 105,
    x2: 54,
    y2: 15,
    stroke: "url(#fireGrad2)",
    strokeWidth: 2.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 10               C54 10, 75 -20, 72 -50               C70 -65, 65 -75, 58 -82              C60 -70, 55 -60, 55 -55              C55 -50, 62 -40, 62 -40              C62 -40, 50 -55, 48 -70              C46 -80, 50 -95, 54 -105              C42 -90, 34 -75, 33 -60              C32 -45, 36 -25, 54 10Z",
    fill: "url(#fireGrad2)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 5               C54 5, 64 -15, 62 -35              C61 -45, 58 -55, 54 -62              C50 -55, 45 -40, 44 -30              C43 -18, 47 -5, 54 5Z",
    fill: "#fbbf24",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54 60 L0 30 L54 -20",
    stroke: "url(#fireGrad2)",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.4,
    strokeDasharray: "4 4"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 355,
    textAnchor: "middle",
    fontFamily: "'Kanit', sans-serif",
    fontWeight: 900,
    fontSize: 56,
    letterSpacing: 10,
    fill: "url(#fireGrad2)"
  }, "IGNIS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConcept2ChartFlame);
export default __webpack_public_path__ + "static/media/logo-concept-2-chart-flame.7627e869c04daaabdec56cf9813f4631.svg";
export { ForwardRef as ReactComponent };